import { render, staticRenderFns } from "./EiArticleCategory.vue?vue&type=template&id=a4fd56aa&scoped=true&"
import script from "./EiArticleCategory.vue?vue&type=script&lang=js&"
export * from "./EiArticleCategory.vue?vue&type=script&lang=js&"
import style0 from "./EiArticleCategory.vue?vue&type=style&index=0&id=a4fd56aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fd56aa",
  null
  
)

export default component.exports